<template>
  <div
    :class="{
      error: error,
    }"
  >
    <div class="title">Варианты ответа</div>
    <transition-group name="slide" tag="div">
      <div v-for="variant in value" :key="variant.unique" class="variant">
        <c-input
          v-model="variant.text"
          :data-variant="variant.unique"
          class="variant__field"
          :max-length="255"
          :clearable="true"
          :required="error"
          :required-message="error"
          placeholder="Введите текст ответа"
          @enter="onEnter"
        />
        <c-button
          v-if="value.length > 1"
          v-b-popover.hover.blur.top="'Удалить'"
          class="variant__remove"
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          @click="remove(variant)"
        />
      </div>
    </transition-group>

    <c-button
      class="add-variant"
      size="small"
      :icon="{ icon: 'plus', color: 'primary' }"
      label="Добавить вариант"
      :disabled="disableAddButton"
      @click="add"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";

import { FieldVariant } from "@/domains/profile/models/ProfileFieldVariant";

export default {
  components: { CInput, CButton },
  props: ["value", "error"],

  data() {
    return {
      toFocus: null,
    };
  },

  computed: {
    disableAddButton() {
      return this.value.some((v) => !v.text.trim());
    },
  },

  watch: {
    value: {
      handler() {
        this.$emit("change");
      },
      deep: true,
    },
  },

  created() {
    if (!this.value.length) {
      this.add();
    }
  },

  updated() {
    if (this.toFocus) {
      this.$nextTick(() => {
        const variant = this.$el.querySelector(`[data-variant="${this.toFocus}"]`);
        if (variant) {
          const input = variant.querySelector("input");
          if (input) input.focus();
        }
        this.toFocus = null;
      });
    }
  },

  methods: {
    add() {
      const newVariant = FieldVariant();
      this.toFocus = newVariant.unique;
      this.$emit("input", [...this.value, newVariant]);
    },
    remove(variant) {
      const updatedValue = this.value.filter((v) => v !== variant);
      this.$emit("input", updatedValue);
    },
    onEnter() {
      if (!this.disableAddButton) this.add();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 15px;
}
.add-variant {
  margin-top: 20px;
}
.variant {
  display: flex;
  margin-bottom: 20px;
  &__field {
    flex-grow: 1;
  }
  &__remove {
    flex-shrink: 0;
    margin-left: 25px;
    transform: translateY(-4px);
  }

  &:not(:last-child) {
    /deep/ {
      .c-input-required {
        display: none;
      }
    }
  }
}

.error {
  .add-variant {
    margin-top: 48px;
  }
}
</style>
